import PolicyLayout, { PolicyCallout, PolicyList, PolicySection } from "@/pages/policies/components/PolicyLayout";

export default function GuestStandardsPage() {
  return (
    <PolicyLayout
      eyebrow="Policies"
      title="Guest Standards & Prohibited Uses"
      updated="1 October 2026"
      intro="A Gari car belongs to a real person in your community. Treat it the way you would want yours treated. These standards keep cars in great shape for everyone — and following them protects your account and your protection plan."
    >
      <PolicySection id="returning" title="1. How to return the car">
        <PolicyList
          items={[
            "Return the car on time, at the agreed place, in the same condition you received it.",
            "Bring the fuel back to the level it was at pickup — the walkaround notes and photos record the starting level.",
            "Give the car a basic tidy: remove your rubbish, personal items and any pet hair or sand.",
            "Report any new damage, warning light, or mechanical issue to the host straight away.",
          ]}
        />
        <p>
          If the car needs more than a light clean after your trip — heavy soiling, spills, smoke or pet odour — a
          cleaning fee may apply.
        </p>
      </PolicySection>

      <PolicySection id="smoking" title="2. Smoking and vaping">
        <p>
          Smoking or vaping in a Gari car is not allowed. Even a single cigarette can leave a lasting smell that
          affects every future rider, and a cleaning fee will be charged for smoking, vaping or related odour or burns.
        </p>
      </PolicySection>

      <PolicySection id="pets" title="3. Pets">
        <p>
          Pets are welcome only if the host has said so in the listing. Where pets are allowed, use a carrier or seat
          cover, and return the car free of hair and odour. Transporting a pet in a car where they are not permitted
          may trigger a cleaning fee.
        </p>
      </PolicySection>

      <PolicySection id="prohibited" title="4. Prohibited uses — never do this">
        <PolicyList
          items={[
            "Off-road, on the beach, in rivers or on any unsealed track the car is not built for.",
            "Racing, track days, drifting, timed runs or any form of motorsport.",
            "Towing trailers, other vehicles or heavy loads unless the host has agreed in writing.",
            "Letting anyone who is not an approved driver take the wheel.",
            "Driving under the influence of alcohol or drugs, or without a valid licence.",
            "Using the car for ride-hailing, delivery, courier work or any commercial-for-hire purpose.",
            "Subletting or re-renting the car to someone else.",
            "Carrying illegal goods, or using the car in the commission of any crime.",
            "Removing parts, swapping tyres, or making modifications without the host&apos;s consent.",
          ]}
        />
        <PolicyCallout icon="ri-alert-line">
          Breaching these rules can void your protection plan, lead to recovery charges, and result in your account
          being suspended or removed from Gari.
        </PolicyCallout>
      </PolicySection>

      <PolicySection id="smoking-alt" title="5. Roads and conditions">
        <p>
          Stay on public, made-up roads for ordinary cars. If a trip involves rough terrain, confirm in advance that the
          host&apos;s car is suitable and that it is permitted by the listing. Vehicles are not to be used on roads that
          are closed, flooded or unsafe.
        </p>
      </PolicySection>

      <PolicySection id="fines" title="6. Fines, tolls and impounds">
        <p>
          You are responsible for any traffic fines, tolls or penalties incurred during your trip, and for any impound
          or recovery cost caused by how the car was used. If we pay a fine on your behalf so the host is not
          penalised, we will pass the cost on to you along with an administration fee.
        </p>
      </PolicySection>

      <PolicySection id="accidents" title="7. If something goes wrong">
        <PolicyList
          items={[
            "Make sure everyone is safe and move to a safe place if you can.",
            "Call emergency services if anyone is injured or the road is blocked.",
            "Tell the host and Gari as soon as possible, and keep any police or third-party details.",
            "Record photos of the scene and the car, and do not admit fault on the spot.",
          ]}
        />
      </PolicySection>

      <PolicySection id="consequences" title="8. Consequences">
        <p>
          Standards are enforced with care. Depending on the breach, we may charge a fee, decline a damage claim, add a
          note to your account, or suspend or remove your access to Gari. Repeated poor behaviour affects the whole
          community, so we take it seriously.
        </p>
      </PolicySection>
    </PolicyLayout>
  );
}